<template>
  <div>
    <SignUpForm @signUp="signup" @signInHereButton="signInHereButton" />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import SignUpForm from "@/components/SignUpForm.vue";
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import mixins from "vue-typed-mixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import FieldValidationMixin from "@/mixins/FieldValidationMixins";
import { wait } from "@/services/CommonService";

export default mixins(SnackbarNotifierMixin, FieldValidationMixin).extend({
  name: "Signup",
  components: { SnackbarNotifier, SignUpForm },
  data() {
    return {};
  },
  methods: {
    async signup(customerInfo) {
      try {
        const result = await ApiService.Instance.signUp(customerInfo);

        if (result) {
          this.showNotifier({
            message: `Account created successfully. Please check your email for the confirmation link`,
            snackbarType: "success",
          });
          await wait(500);
          this.$router.push({ name: "Login" });
        }
      } catch (e) {
        error(e);

        if (e.response.data.errorType == "EmailAlreadyExist") {
          this.showNotifier({
            message: `An account with this email already exists`,
            snackbarType: "error",
          });
        } else {
          this.showNotifier({
            message: `Failed to create account`,
            snackbarType: "error",
          });
        }
      }
    },
    signInHereButton() {
      this.$router.push({ name: "Login" });
    },
  },
});
</script>

<style scoped>
.error-text {
  color: red;
}
</style>
